<template>
  <div class="cst-page-table-box">
    <div
      class="table-viewport"
      ref="customTableBoxRef">
      <div class="table-inner-wrap">
        <StandardTable
          ref="table"
          :size="size"
          :rowKey="rowKey?rowKey:autoRowKey"
          :columns="columns"
          :pageNum="currentPage"
          :pageSize="currentPageSize"
          :data="loadDataRequest"
          :rowSelection="rowSelection"
          :childrenColumnName="childrenColumnName"
          :useScroll="true"
          :pagination="false">
          <template v-for="slotName in Object.keys($scopedSlots)" :slot="slotName" slot-scope="pageScope">
            <slot :name="slotName" v-bind="pageScope"/>
          </template>
        </StandardTable>
      </div>
    </div>
    <div class="custom-pagination-box" v-if="customPagination" ref="customPaginationTop">
      <div style="display: inline-block">
        <slot :name="extraPaginationName" :total="totalCount"/>
      </div>
      <div style="display: inline-block;float: right;" v-if="totalPage>1 && totalCount>currentPageSize">
        <a-pagination
          :total="totalCount"
          :showTotal="total => `总共 ${total} 条`"
          :pageSize="currentPageSize"
          showSizeChanger
          v-model="currentPage"
          @change="onPageChange"
          @showSizeChange="onShowSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
//自定义分页加载组件（包装原始组件）
import StandardTable from './StandardTable.vue'

export default {
  name: 'CustomPageTable',

  components: { StandardTable },
  props: {
    rowKey: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    rowSelection: {
      type: Object,
      default: null
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageNum: {
      type: Number,
      default: 1
    },
    requestType: {
      type: String,
      default: 'post'
    },
    //查询式请求路径
    queryPath: {
      type: String,
      default: ''
    },
    //参数式请求路径
    paramsPath: {
      type: String,
      default: ''
    },
    //请求基础模块
    baseKey: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    },
    //请求的
    requestPromise: {
      type: Function,
      default: undefined
    },
    loadData: {
      type: Function,
      default: undefined
    },
    //查询参数
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    showResetButton: {
      type: Boolean,
      default: false
    },
    // 自定义分页显示
    customPagination: {
      type: Boolean,
      default: true
    },
    //分页附加信息
    extraPaginationName: {
      type: String,
      default: 'extraPaginationName'
    },
    childrenColumnName: {
      type: String,
      default: 'children'
    },
    expandedRowRender: {
      type: String,
      default: ''
    },
    maxTableHeight: {
      type: Number,
      default: document.body.clientHeight
    }
  },
  watch: {
    //当前页数变换监听
    'currentPage': function(newVal, oldVal) {
      this.$emit('pageChange', newVal)
    },
    'columns': function(columnsList) {
      this.customRenders = this.getCustomRendersList(columnsList)
      this.headerRenders = this.getHeaderRendersList(columnsList)
    },
    'pageSize': function(pageSize) {
      this.currentPageSize = pageSize
      setTimeout(() => this.refresh(true), 500)
    },
    'pageNum': function(pageNum) {
      this.currentPage = pageNum
      setTimeout(() => this.refresh(false), 500)
    }

  },
  data() {
    return {
      autoRowKey: 'autoRowKey',
      autoRowNum: 1,
      customRenders: [],
      headerRenders: [],
      currentPage: 1,
      currentPageSize: 10,
      totalCount: 0,
      totalPage: 0,
      tableBoxHeight: 0,
      tableBoxWidth: 0,
      resizeObserver: null, // 保存 observer 实例，以便后续销毁
      timer: null
    }
  },

  created() {
    this.currentPageSize = this.pageSize
  },
  mounted() {
    this.customRenders = this.getCustomRendersList(this.columns)
    this.headerRenders = this.getHeaderRendersList(this.columns)
    this.$nextTick(() => {
      const element = this.$refs.customTableBoxRef
      if (!element) return

      this.resizeObserver = new window.ResizeObserver(entries => {
        if (!entries?.length || !entries[0]?.contentRect) return
        const entryHeight = entries[0].contentRect.height
        const realW = element.clientWidth
        const realH = element.clientHeight
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.timer = undefined
          const newH = Math.max(realH, this.maxTableHeight)
          if (this.tableBoxHeight !== newH) {
            this.tableBoxHeight = newH
          }
          if (this.tableBoxWidth !== realW) {
            this.tableBoxWidth = realW
          }
        }, 100)
      })
      this.resizeObserver.observe(element)
    })
  },
  beforeDestroy() {
    // 组件销毁前，记得断开观察器，防止内存泄漏
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$refs.customTableBoxRef)
      this.resizeObserver.disconnect()
    }
    if (this.timer) clearTimeout(this.timer)
  },
  methods: {
    loadDataRequest(parameter) {
      this.getLogUtils().logWithTag('parameter', parameter)
      return new Promise((resolve, reject) => {
        const result = this.loadData ? this.loadData(parameter) : this.getDefaultDataList(parameter)
        resolve(result)
      }).then(res => {
        this.currentPage = parameter.pageNo
        this.currentPageSize = parameter.pageSize
        this.totalCount = res.totalCount
        this.totalPage = res.totalPage
        return res
      })
    },

    getCustomRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.scopedSlots && item.scopedSlots.customRender) {
            customList.push(item.scopedSlots.customRender)
          }
        })
      }
      return customList
    },
    getHeaderRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          if (item && item.slots && item.slots.title) {
            customList.push(item.slots.title)
          }
        })
      }
      return customList
    },
    refresh(bool = false) {
      if (bool && this.customPagination) {
        //自定义分页 要在这里重置为第一页
        this.currentPage = 1
        setTimeout(() => this.$refs.table.refresh(bool), 200)
      } else {
        this.$refs.table.refresh(bool)
      }
    },
    //加载接口默认实现
    getDefaultDataList(parameter) {
      let requestPromise
      if ((this.queryPath || this.paramsPath) && this.requestType && this.baseKey) {//传统的老项目请求方式
        let path
        if (this.paramsPath) {
          path = this.paramsPath + '/' + parameter.pageNo + '/' + parameter.pageSize
        } else {
          path = this.queryPath + '?pageNum=' + parameter.pageNo + '&pageSize=' + parameter.pageSize
        }
        const baseService = this.getHttpServices().getCommonService(this.baseKey)
        requestPromise = this.requestType === 'post' ? baseService.post(path, this.queryParams) : baseService.get(path, this.queryParams)
      } else {
        let requestParams
        if (this.requestType === 'post') {
          requestParams = {
            ...this.queryParams,
            limitDto: {
              pageNum: parameter.pageNo,
              pageSize: parameter.pageSize
            }
          }
        } else {
          requestParams = {
            pageSize: parameter.pageSize,
            pageNum: parameter.pageNo,
            ...this.queryParams
          }
        }
        this.getLogUtils().logWithTag('requestParams', requestParams)
        requestPromise = this.requestPromise(requestParams, parameter)
      }

      return requestPromise.then(res => {
        if (!this.rowKey && res.data && res.data.length > 0) {
          //没有传key，则自动构建一个唯一的可以
          for (let i = 0, len = res.data.length; i < len; i++) {
            this.autoRowNum = this.autoRowNum + i
            res.data[i][this.autoRowKey] = this.autoRowKey + this.autoRowNum
          }
        }
        return {
          pageSize: parameter.pageSize,
          pageNo: parameter.pageNo,
          totalCount: res.totalCount,
          totalPage: res.pageCount,
          data: res.data
        }
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        return {
          pageSize: parameter.pageSize,
          pageNo: parameter.pageNo,
          totalCount: 0,
          totalPage: 0,
          data: []
        }
      })
    },

    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.currentPageSize = pageSize
      this.$emit('changePageParameter') //修改可变参数
      setTimeout(() => this.refresh(true), 500)
    },
    onPageChange(page, pageSize) {
      this.currentPage = page
      this.currentPageSize = pageSize
      this.$emit('changePageParameter')//修改可变参数
      setTimeout(() => this.refresh(false), 500)
    },
    updateSelect(selectedRowKeys, selectedRows) {
      this.$refs.table.updateSelect(selectedRowKeys, selectedRows)
    }
  }

}
</script>
<style scoped lang="less">
.cst-page-table-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-shrink: 0;

  .def-box {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .table-viewport {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
    min-height: 220px;
    box-sizing: border-box;
  }

  .table-inner-wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: calc(100% - 16px); /* 底部减去16px，给横向滚动条预留空间 \*/
    width: 100%;
    //height: 100%;
    overflow: visible;
  }
}

.custom-pagination-box {
  padding-top: 10px;
  width: 100%;
}


</style>